import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import Header from "./components/Header";
import Cart from "./pages/cart";
import ProductDetail from "./pages/productDetail";
import Checkout from "./pages/checkout";
import Order from "./pages/order";
import MyOrders from "./pages/my-orders";
import Panel from "./pages/panel";
import RelatoryOrders from "./pages/relatory-orders";
import Clients from "./pages/clients";
import Ranking from "./pages/ranking";
import Products from "./pages/products";
import CartAbandoned from "./pages/cart-abandoned";
import CartAbandonedDetail from "./pages/cart-abandoned/detail";
import DiscountCoupon from "./pages/discount-coupon";
import Login from "./pages/login";
import Register from "./pages/register";
import ForgotPassword from "./pages/forgot-password";
import ResetPassword from "./pages/reset-password";
import NotFound from "./pages/not-found";
import SessionVerify from "./helpers/SessionVerify";
import GuestVerify from "./helpers/GuestVerify";
import AdminLogin from "./pages/admin-login";
import AdminVerify from "./helpers/AdminVerify";
import ProductImages from "./pages/product-images";
import DatabaseConfig from "./pages/database-config";
import MasterVerify from "./helpers/MasterVerify";
import AccessSettings from "./pages/access-settings";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/catalogo/:clientHash/:sellerId" element={<Home />} />
        <Route
          path="/login/:clientHash/:sellerId"
          element={
            <>
              <GuestVerify />
              <Login />
            </>
          }
        />
        <Route
          path="/login"
          element={
            <>
              <GuestVerify />
              <Login />
            </>
          }
        />
        <Route path="/register/:clientHash/:sellerId" element={<Register />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/esqueci-senha/:clientHash/:sellerId"
          element={<ForgotPassword />}
        />
        <Route path="/esqueci-senha" element={<ForgotPassword />} />
        <Route
          path="/redefinir-senha/:clientHash/:token"
          element={<ResetPassword />}
        />
        <Route path="/redefinir-senha/:token" element={<ResetPassword />} />
        <Route path="/carrinho/:clientHash/:sellerId" element={<Cart />} />
        <Route
          path="/produto/:id/:clientHash/:sellerId"
          element={<ProductDetail />}
        />
        <Route path="/checkout/:clientHash/:sellerId" element={<Checkout />} />
        <Route path="/pedido/:id" element={<Order />} />
        <Route
          path="/meus-pedidos"
          element={
            <>
              <SessionVerify />
              <MyOrders />
            </>
          }
        />
        <Route
          path="/painel"
          element={
            <>
              <AdminVerify />
              <Panel />
            </>
          }
        />
        <Route
          path="/painel/relatorios-pedidos"
          element={
            <>
              <AdminVerify />
              <RelatoryOrders />
            </>
          }
        />
        <Route
          path="/painel/clientes-cadastrados"
          element={
            <>
              <AdminVerify />
              <Clients />
            </>
          }
        />
        <Route
          path="/painel/ranking"
          element={
            <>
              <AdminVerify />
              <Ranking />
            </>
          }
        />
        <Route
          path="/painel/produtos"
          element={
            <>
              <AdminVerify />
              <Products />
            </>
          }
        />
        <Route
          path="/painel/produtos/:id/imagens"
          element={
            <>
              <AdminVerify />
              <ProductImages />
            </>
          }
        />
        <Route
          path="/painel/carrinhos-abandonados"
          element={
            <>
              <AdminVerify />
              <CartAbandoned />
            </>
          }
        />
        <Route
          path="/painel/carrinhos-abandonados/:id"
          element={
            <>
              <AdminVerify />
              <CartAbandonedDetail />
            </>
          }
        />
        <Route
          path="/painel/database-config"
          element={
            <>
              <MasterVerify />
              <DatabaseConfig />
            </>
          }
        />
        <Route
          path="/painel/cupom"
          element={
            <>
              <AdminVerify />
              <DiscountCoupon />
            </>
          }
        />
        <Route
          path="/painel/configuracoes-acesso"
          element={
            <>
              <AdminVerify />
              <AccessSettings />
            </>
          }
        />
        <Route path="/*" element={<NotFound />} />
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
    </BrowserRouter>
  );
}
